import type { HealthCondition } from '@/modules/api';

import { WHITELISTED_HEALTH_CONDITIONS } from '../constants/healthConditions';

/**
 * Narrows the raw `/api/v4/health_conditions/` catalog to the keys the survey is
 * allowed to show (dropping e.g. `overweight` / `obesity`), then sorts by
 * display name for stylos's alphabetical ordering. Mirrors Sparta's
 * `getHealthConditions` selector. Returns a new array — never mutates `catalog`.
 */
export function selectWhitelistedConditions(catalog: HealthCondition[]): HealthCondition[] {
  return catalog
    .filter((condition) => WHITELISTED_HEALTH_CONDITIONS.includes(condition.key))
    .sort((a, b) => a.displayName.localeCompare(b.displayName));
}
